"use client";

import { useState, useCallback, useEffect } from "react";
import DocumentsListPage from "./DocumentsListPage";
import DocumentsUploadPage from "./DocumentsUploadPage";

type ViewType = "list" | "upload";

export default function DocumentsShell() {
  const [view, setView] = useState<ViewType>("list");

  const goToList = useCallback(() => setView("list"), []);
  const goToUpload = useCallback(() => setView("upload"), []);
  const handleUploaded = useCallback(() => goToList(), [goToList]);

  return (
    <>
      {view === "list" && <DocumentsListPage onUpload={goToUpload} />}
      {view === "upload" && <DocumentsUploadPage onBack={goToList} onSuccess={handleUploaded} />}
    </>
  );
}
